<!-- Utilisation de la structure de la modale du fichier roles.html -->
<div class="modal" id="new-role" style="display: block;">
  <div class="modal-content">
    <!-- Bouton fermeture -->
    <span class="close" (click)="onCancel()">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19.0005 5L5.00049 19M5.00049 5L19.0005 19" stroke="#5C6465" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </span>

    <div class="modal-content-view">
      <div>
        <h4>{{ isEditMode ? 'Modifier le rôle' : 'Créer un nouveau rôle' }}</h4>
        @if (isEditMode) {
          <p class="text-gray">Modifiez les informations du rôle</p>
        }
      </div>

      <form [formGroup]="roleForm" (ngSubmit)="onSubmit()">
        <div class="grid gap-16">
          <!-- Type de rôle (uniquement en création) -->
          @if (!isEditMode) {
            <div class="field-wrapper">
              <label>Type de rôle</label>
              <div class="select-wrapper">
                <select formControlName="roleType">
                  <option value="client" selected>Rôle Client – spécifique à une application</option>
                  <option value="realm">Rôle Realm – global au realm</option>
                </select>
              </div>
              @if (hasError('roleType')) {
                <div class="text-error">{{ getErrorMessage('roleType') }}</div>
              }
            </div>
          }

          <!-- Application cliente (si rôle client et création) -->
          @if (!isRealmRole && !isEditMode) {
            <div class="field-wrapper">
              <label>Application cliente</label>
              <div class="select-wrapper">
                <select formControlName="clientId">
                  <option value="" disabled selected>Sélectionner une application</option>
                  @for (client of clients; track client) {
                    <option [value]="client.id">
                      {{ client.name || client.clientId }}
                    </option>
                  }
                </select>
              </div>
              @if (hasError('clientId')) {
                <div class="text-error">{{ getErrorMessage('clientId') }}</div>
              }
            </div>
          }

          <!-- Nom du rôle -->
          <div class="field-wrapper">
            <label for="roleName">Nom du rôle (Code)</label>
            <input id="roleName" type="text" class="field" formControlName="name"
              placeholder="ex: admin, user, manager"
              [readonly]="isEditMode">
              @if (!isEditMode) {
                <span class="field-hint">* Uniquement lettres, chiffres, tirets et underscores</span>
              }
              @if (isEditMode) {
                <span class="field-hint">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#5C6465">
                    <path d="M12 4V20M4 12H20" stroke="currentColor" stroke-width="1.5"/>
                  </svg>
                  Le nom ne peut pas être modifié
                </span>
              }
              @if (hasError('name')) {
                <div class="text-error">{{ getErrorMessage('name') }}</div>
              }
            </div>

            <!-- Libellé -->
            <div class="field-wrapper">
              <label for="roleTitle">Libellé</label>
              <input id="roleTitle" type="text" class="field" formControlName="title"
                placeholder="Libellé (titre) du rôle" maxlength="100">
                @if (hasError('title')) {
                  <div class="text-error">{{ getErrorMessage('title') }}</div>
                }
              </div>

              <!-- Description -->
              <div class="field-wrapper">
                <label for="roleDescription">Description</label>
                <textarea id="roleDescription" class="field" formControlName="description"
                placeholder="Décrivez le rôle..." rows="3" maxlength="255"></textarea>
                <span class="field-hint align-right">{{ roleForm.get('description')?.value?.length || 0 }} / 255</span>
                @if (hasError('description')) {
                  <div class="text-error">{{ getErrorMessage('description') }}</div>
                }
              </div>
            </div>

            <!-- Actions -->
            <div class="two-columns gap-16 fix-bottom">
              <button type="button" class="button neutral" (click)="onCancel()" [disabled]="submitting">Annuler</button>
              <button type="submit" class="button primary" [disabled]="roleForm.invalid || submitting">
                @if (submitting) {
                  <span>En cours...</span>
                }
                @if (!submitting) {
                  <span>{{ isEditMode ? 'Mettre à jour' : 'Enregistrer' }}</span>
                }
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>